<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.withdraw.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="box-withdraw">
          <div class="from">
            <hooper
              ref="withdraw"
              :vertical="true"
              :itemsToShow="1"
              :centerMode="true"
              class="box-slide"
            >
              <!-- <slide>
                <div>
                  <div class="box-title">เลือกบัญชี</div>
                  <div class="name">ที่ต้องการถอนเงิน</div>
                </div>
              </slide> -->
              <slide>
                <div>
                  <img src="@/assets/images/wallet.png" />
                  <div class="name">{{ $t('modals.transfer.walletTxt') }}</div>
                  <div class="amount">{{ total | numberFormat }}</div>
                </div>
              </slide>
              <!-- <slide
                v-for="(slot, index) in findSlotsActive(slots)"
                :key="index"
              >
                <div>
                  <img :src="slot.logo" />
                  <div class="name">{{ slot.name }}</div>
                  <div class="amount">{{ slot.amount | numberFormat }}</div>
                </div>
              </slide> -->
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
          </div>
        </div>
        <form @submit.prevent="handleWithdraw">
          <div class="field m-t-30">
            <label for="" class="label"
              >{{ $t('modals.amountLabel') }}
              <span class="note"
                >**{{ $t('modals.transfer.minAmountLabel') }}
                {{ minWithdraw | decimalFormat }}
                {{ $t('modals.transfer.bahtTxt') }} /
                {{ $t('modals.withdraw.maxTxt') }}
                {{ maxWithdraw | decimalFormat }}
                {{ $t('modals.transfer.bahtTxt') }}**</span
              ></label
            >
            <div class="field m-t-10 has-text-danger">
              <b>***{{ $t('modals.withdraw.bonusConTxt') }}***</b>
            </div>
            <div class="control has-icons-left">
              <input
                v-model="amount"
                ref="input"
                type="number"
                min="0"
                :placeholder="$t('modals.transfer.amountPla')"
                class="input text-center"
                @click="selectAll"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-coins"></i>
              </span>
            </div>
          </div>
          <div class="box-button m-t-30">
            <button class="button full-50 is-light" @click="closeModal">
              {{ $t('modals.cancelBtn') }}
            </button>
            <button type="submit" class="button full-50 is-primary">
              {{ $t('modals.withdraw.confBrn') }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import apiLookup from '@/api/lookup'
import apiWallet from '@/api/wallet'

import _ from 'lodash'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'
import i18n from '@/language'
export default {
  name: 'ModalWithdraw',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    wallet: {
      type: Object
    },
    slots: {
      type: Array
    }
  },
  data() {
    return {
      minWithdraw: 0,
      maxWithdraw: 0,
      amount: '',
      total: 0
    }
  },
  mounted() {
    this.$refs.withdraw.restart()
    this.$refs.withdraw.slideTo(0)

    this.lookup()

    this.total = parseInt(this.wallet.amount)
    this.total += _.sumBy(this.slots, o => {
      if (o.isActive) return parseInt(o.amount)
      else return 0
    })
  },
  methods: {
    async lookup() {
      const data = await apiLookup.lookupWithdraw()
      this.minWithdraw = data.withdrawMin
      this.maxWithdraw = data.withdrawMax
    },
    async withdraw() {
      // check min / max
      if (this.amount < this.minWithdraw)
        return this.showErrorAlert(
          `${i18n.t('modals.transfer.minAmountMsg')} ${
            this.minWithdraw
          } ${i18n.t('modals.transfer.bahtTxt')}`
        )

      if (this.amount > this.maxWithdraw)
        return this.showErrorAlert(
          `${i18n.t('modals.withdraw.maxAmountMsg')} ${
            this.maxWithdraw
          } ${i18n.t('modals.transfer.bahtTxt')}`
        )

      let loading = this.$loading.show()
      setTimeout(async () => {
        try {
          const result = await apiWallet.withdrawAll(this.amount)
          if (result) {
            this.$emit('closeModal', true)

            this.showSuccessAlert()
          }
        } catch (error) {
          this.showErrorAlert(error)
        } finally {
          loading.hide()
        }
      }, 200)
    },
    closeModal() {
      this.$emit('closeModal', null)
    },
    findSlotsActive(slots) {
      return _.filter(slots, { isActive: true })
    },
    handleWithdraw() {
      this.withdraw()
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.withdraw.waiteTransfer'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    },
    selectAll() {
      this.$refs.input.select()
    }
  }
}
</script>

<style scoped lang="scss">
.box-withdraw {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
  text-shadow: -1px -1px 0px #000, 0px -1px 0px #000, 1px -1px 0px #000,
    -1px 0px 0px #000, 1px 0px 0px #000, -1px 1px 0px #000, 0px 1px 0px #000,
    1px 1px 0px #000;
  color: #ffffff;

  .box-title {
    font-size: 20px;
  }

  .box-slide {
    height: 150px;
  }

  .from {
    text-align: center;
    width: 190px;
    background: url('/images/bg-transfer.png') no-repeat;
    background-size: 100% 100%;
    padding: 10px 0;
    border-radius: 10px;
    max-width: 190px;

    img {
      width: auto;
      height: 60px;
    }
    .name {
      font-size: 12px;
    }
    .amount {
      font-weight: 700;
      font-size: 20px;
    }
  }
}
.note {
  font-size: 14px;
  color: $danger;
}
</style>
